import { useEffect } from 'react'
import { useWorkspace } from '../../context/useWorkspace'
import { useAutomations, useAutomationGraphs } from '../../hooks/useAutomations'
import { setAutomationBusSnapshot } from '../../services/automationBus'

/** Bridge (no children): subscribes to both v1 AutomationDefinitions and v2
 * AutomationGraphs for the active workspace and mirrors them into the
 * module-level automationBus snapshot. Emit sites throughout the app call
 * fireAutomationEvent without needing their own subscription. */
export const AutomationDispatchBridge = () => {
  const { activeWorkspaceId, canPerform } = useWorkspace()
  const canView = canPerform('automation.view')
  const workspaceId = canView ? activeWorkspaceId : null
  const { items: definitions } = useAutomations(workspaceId)
  const { items: graphs } = useAutomationGraphs(workspaceId)

  useEffect(() => {
    setAutomationBusSnapshot(workspaceId, definitions, graphs)
    return () => setAutomationBusSnapshot(null, [], [])
  }, [workspaceId, definitions, graphs])

  return null
}
